const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  sync2Item ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyb/v1frontend/tp-catalog-qa/sync2-item', params)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
